// overlayKit/utils.ts — production-universal helpers, no production-specific values.
// Resolution + fps come from the parent <Composition> via Remotion's useVideoConfig().
import { interpolate } from "remotion";

export const clamp = {
  extrapolateLeft: "clamp" as const,
  extrapolateRight: "clamp" as const,
};

// Triple-stacked text shadow — the canonical legibility trick. Used on every text element.
export const TS =
  "0 3px 14px rgba(0,0,0,0.92), 0 1px 5px rgba(0,0,0,0.95), 0 0 2px rgba(0,0,0,0.9)";

export const FONT = "Inter, system-ui, sans-serif";

// Card opacity window: fade in over 0.22s starting at inS, fade out over 0.35s ending at outS.
export const win = (t: number, inS: number, outS: number): number =>
  interpolate(t, [inS, inS + 0.22, outS - 0.35, outS], [0, 1, 1, 0], clamp);

// Element opacity: fade-in starting AT atS, finishing `dur` seconds later.
export const appear = (t: number, atS: number, dur = 0.18): number =>
  interpolate(t, [atS, atS + dur], [0, 1], clamp);

// Standard layout vocabulary — x positions computed against the composition's actual width.
// Same component renders correctly at any aspect ratio because positions scale with width.
export type Layout =
  | "center"
  | "left-half"
  | "right-half"
  | "left-third"
  | "center-third"
  | "right-third"
  | "custom";

export const layoutX = (layout: Layout, width: number, customX?: number): number => {
  // Rounded to integer pixels so sub-pixel positions never cause anti-aliasing drift
  // between renders. (At 1280: right-third = 5×1280/6 = 1066.67 → rounds to 1067, same
  // value the hand-tuned UraniumSeg1 used.)
  switch (layout) {
    case "center":       return Math.round(width / 2);
    case "left-half":    return Math.round(width / 4);
    case "right-half":   return Math.round((3 * width) / 4);
    case "left-third":   return Math.round(width / 6);
    case "center-third": return Math.round(width / 2);
    case "right-third":  return Math.round((5 * width) / 6);
    case "custom":
      if (customX == null) throw new Error('layout="custom" requires an explicit x');
      return customX;
  }
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
